import Tasks from "./Tasks/index.js";
class Index {
    rc;
    _parent;
    constructor(_parent) {
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/extension-bulk-update`;
    }
    /**
     * Updates multiple extensions at once. Maximum 500 extensions can be updated per request.
     *
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension-bulk-update
     * Rate Limit Group: Heavy
     * App Permission: EditExtensions
     * User Permission: EditExtensionInfo
     */
    async post(extensionBulkUpdateRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(), extensionBulkUpdateRequest, undefined, restRequestConfig);
        return r.data;
    }
    tasks(taskId = null) {
        return new Tasks(this, taskId);
    }
}
export default Index;
